import axios from 'axios';

const service = axios.create({
    timeout: 90000,
    headers: {
        'Content-Type': 'application/json'
    }
});

service.interceptors.request.use(config => {
    const btn = window.__btnLock && window.__btnLock.takePendingBtn();
    if (btn) {
        clearTimeout(btn.__unlockTimer__);
        config.__lockedBtn__ = btn;
    }
    return config;
});

service.interceptors.response.use(
    response => {
        const btn = response.config.__lockedBtn__;
        if (btn) btn.classList.remove('is-clicking');
        return response;
    },
    error => {
        const btn = error.config && error.config.__lockedBtn__;
        if (btn) btn.classList.remove('is-clicking');
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('gamingToken');
        }
        return Promise.reject(error);
    }
);

export default service;
